import React, { ReactNode, ChangeEvent, MouseEvent } from 'react';

import SearchInput from 'Shared/components/SearchInput/SearchInput';

import './SyncMeetingsModalBodyWrapper.scss';

type Props = {
  description: string | ReactNode;
  searchValue: string;
  showViewMoreButton: boolean;
  recurringMeetingsLabel?: string;
  showSearchInput?: boolean;
  viewMoreButtonText: string;
  searchPlaceholder?: string;
  children: ReactNode;
  onSearchValueChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onViewMoreClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

function SyncMeetingsModalBodyWrapper({
  description,
  searchValue,
  searchPlaceholder = 'Search...',
  showViewMoreButton,
  showSearchInput = true,
  recurringMeetingsLabel,
  viewMoreButtonText,
  children,
  onSearchValueChange,
  onViewMoreClick,
}: Props) {
  return (
    <div className="sync-meeting-modal">
      <div className="sync-meeting-modal-description mb-3">{description}</div>

      {/* <div className="sync-meeting-modal-short-description text-muted mt-3 mb-1 font-weight-bold">
        Search For Meetings
      </div> */}
      {showSearchInput && (
        <SearchInput value={searchValue} onChange={onSearchValueChange} placeholder={searchPlaceholder} />
      )}

      {recurringMeetingsLabel ? (
        <div className="sync-meeting-modal-short-description text-muted mt-3 mb-1 font-weight-bold">
          {recurringMeetingsLabel}
        </div>
      ) : (
        <div className="mt-3" />
      )}
      {children}
      {showViewMoreButton && (
        <button type="button" className="btn btn-link px-0 py-0 mt-2" onClick={onViewMoreClick}>
          {viewMoreButtonText}
        </button>
      )}
    </div>
  );
}

export default SyncMeetingsModalBodyWrapper;
